import React, { useMemo } from 'react';
import BaseReportPage from '../../../components/reports/BaseReportPage';

const SupplierReturnsReport = () => {
  const columns = useMemo(() => [
    { 
      key: 'returnId', 
      title: 'Return ID', 
      sortable: true
    },
    { 
      key: 'purchaseOrderNumber', 
      title: 'PO Number', 
      sortable: true
    },
    { 
      key: 'supplierName', 
      title: 'Supplier', 
      sortable: true
    },
    { 
      key: 'branchName', 
      title: 'Branch', 
      sortable: true
    },
    { 
      key: 'itemName', 
      title: 'Item', 
      sortable: true
    },
    { 
      key: 'quantity', 
      title: 'Quantity', 
      sortable: true,
      render: (value) => {
        if (value === null || value === undefined) return '0'
        return parseFloat(value).toLocaleString()
      }
    },
    { 
      key: 'returnAmount', 
      title: 'Return Amount', 
      sortable: true,
      render: (value) => {
        if (value === null || value === undefined) return 'Rs. 0.00'
        const amount = parseFloat(value)
        return `Rs. ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      }
    },
    { 
      key: 'reason', 
      title: 'Return Reason', 
      sortable: false
    },
    { 
      key: 'returnDate', 
      title: 'Return Date', 
      sortable: true,
      render: (value) => {
        if (!value) return '-'
        return new Date(value).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        })
      }
    },
    { 
      key: 'processedBy', 
      title: 'Processed By', 
      sortable: true
    },
    { 
      key: 'status', 
      title: 'Status', 
      sortable: false,
      render: (value) => {
        const statusStyles = {
          'Pending': 'bg-yellow-100 text-yellow-800 border border-yellow-200',
          'Processed': 'bg-green-100 text-green-800 border border-green-200',
          'Cancelled': 'bg-red-100 text-red-800 border border-red-200',
          'Approved': 'bg-blue-100 text-blue-800 border border-blue-200'
        }
        
        const className = statusStyles[value] || 'bg-gray-100 text-gray-800 border border-gray-200'
        
        return (
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${className}`}>
            {value || 'Unknown'}
          </span>
        )
      }
    }
  ], [])

  return (
    <BaseReportPage
      title="Supplier Returns Report"
      subtitle="Track returns and refunds to suppliers"
      reportType="supplierReturns"
      columns={columns}
    />
  );
};

export default SupplierReturnsReport;